
import React, {Component} from 'react'
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DPDocStore  from '../../stores/DPDocStore'
import ConfirmPopup from 'component/element/ConfirmPopup'

class DepositFromWorkRecordModel extends Component {

  constructor(...args){
    super(...args)
    this.state = {showDelete:false,item:{}}
  }

  onDelClick(){
    let {item} = this.state
    DPDocStore.delDPDoc(item.deposit_no,()=>{
      this.props.onHide()
    })
  }

  onRowDelete(item){
    this.setState({showDelete:true,item:item})
  }

  onRowClick(item){
    if(this.props.onSelectItem!==undefined){
      this.props.onSelectItem(item)
    }
  }

  renderRowData(){
    if(this.props.list.length===0){
      return (<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    }
    return this.props.list.map((item,index)=>
    (<tr key={index}>
      <td  className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.added_date}</td>
      <td  className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.deposit_no}</td>
      <td className='text-right' onClick={this.onRowClick.bind(this,item)}>{item.amount}</td>
      <td className='text-center'> <Button bsStyle='danger' onClick={this.onRowDelete.bind(this,item)}><FontAwesome name='trash'/></Button></td>
    </tr>))
  }

  renderTable(){
    let {doc} = this.state
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>วันที่/เวลา</th>                        
            <th className='text-center' style={{width:'70px'}}>เอกสารเลขที่</th>            
            <th className='text-center' style={{width:'120px'}}>มูลค่า</th>
            <th className='text-center' style={{width:'30px'}}>ลบทิ้ง</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>        
      </table>
    )
  }

  renderNewItemButton(){
    return (
      <div >
        <ButtonToolbar className='pull-right'>
          <Button bsStyle='primary' onClick={this.props.onNewDoc}><FontAwesome name='file-o'/>&nbsp;{'สร้างใหม่'}</Button>
          <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{'ยกเลิก'}</Button>
        </ButtonToolbar>        
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {showDelete} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Body>
            {this.renderTable()}
        </Modal.Body>  
        <Modal.Footer>
          {this.renderNewItemButton()}
        </Modal.Footer>   
        <ConfirmPopup
          show={this.state.showDelete}
          onHide={()=>{this.setState({showDelete:false})}}
          title={'ยืนยัน'}
          message={'ยืนยันการลบรายการ?'}
          onConfirm={this.onDelClick.bind(this)}
        />   
      </Modal> 
    )
  }
}

DepositFromWorkRecordModel.defaultProps = {
  show :false,
  list:[]
}


export default DepositFromWorkRecordModel;





// WEBPACK FOOTER //
// ./src/view/so/DepositFromWorkRecordModel.js